
export const ABNORMAL_MSG = {
    NETWORK_OFFLINE: '网络连接异常，请检查网络', //断网
    SERVER_ERROR: '服务器异常，请稍后重试', // 服务异常兜底文案
}